// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__In4Rj","content":"Banner_content__Vx55E","title":"Banner_title__vrrro","text":"Banner_text__gzVC-","image":"Banner_image__VKZVb"};